import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-72c3f677")

_pushScopeId("data-v-72c3f677")
const _hoisted_1 = {
  key: 0,
  class: "poper-top-image yes"
}
const _hoisted_2 = {
  key: 1,
  class: "poper-top-image no"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "poper-wrapper-background",
    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["stop","prevent"]))
  }, [
    _createVNode("div", {
      class: `poper-wrapper ${_ctx.isDrawer ? 'drawer' : ''}`,
      style: 
        _ctx.isDrawer
          ? `background:url(${_ctx.rootUrl}/answer/drawer_award_bg2.png);background-size:100% 100%;`
          : ''
      
    }, [
      (_ctx.isYes)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("img", {
              src: `${_ctx.rootUrl}/answer/answer_get_award.png`
            }, null, 8, ["src"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isNo)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("img", {
              src: `${_ctx.rootUrl}/answer/answer_logout.png`
            }, null, 8, ["src"])
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      _createVNode("div", {
        class: "poper-close",
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["stop","prevent"]))
      }, [
        _createVNode("img", {
          src: `${_ctx.rootUrl}/answer/pop_close.png`
        }, null, 8, ["src"])
      ])
    ], 6)
  ]))
})